import tw, { classnames, textAlign, maxWidth, margin } from 'tailwindcss-classnames'
export const ContainerClass =  classnames(textAlign('xl:text-left'), maxWidth('max-w-2xl', 'md:max-w-3xl'), margin('mx-auto'));